// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__ROI2o","disabled":"Switch_disabled__osKSO","slider":"Switch_slider__UjQVr"};